// @ts-nocheck
/* eslint-disable max-lines-per-function */

import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getSelectedInspection } from '@/selectors';

const BaseComponent = ({ pdc }) => {
    const { inspectionParts = [] } = pdc || {};

    return (
        <div className='border border-color-lighter' data-testid='inspection-results-container'>
            {inspectionParts.map(inspection => (
                <div
                    key={inspection.inspection_part_key}
                    className='display-flex justify-content-between padding-10 border-bottom border-style-solid border-width-1 border-color-lighter'
                >
                    <div className='width-75pct text-medium ellipsis-1'>{inspection.inspection_part_value}</div>
                    {inspection.inspection_result === 'OK' ? (
                        <div className='text-uppercase text-bold text-color-success'>
                            <i className='uikit-icon icon-ok' /> &nbsp;
                            <FormattedMessage id='intl-msg:report.pdc.check.passed' />
                        </div>
                    ) : (
                        <div className='text-uppercase text-bold text-color-danger'>
                            <i className='uikit-icon icon-remove' /> &nbsp;
                            <FormattedMessage id='intl-msg:report.pdc.check.failed' />
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

BaseComponent.propTypes = {
    pdc: PropTypes.object.isRequired,
};

const InspectionResultsContainer = props => {
    const pdc = useSelector(getSelectedInspection);

    return <BaseComponent {...props} pdc={pdc} />;
};

export { BaseComponent };
export default injectIntl(InspectionResultsContainer);
